export default function NoDocumentsIcon() {
	return (
		<svg
			width="254"
			height="202"
			viewBox="0 0 254 202"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_4598_62485)">
				<ellipse
					cx="130.139"
					cy="163.937"
					rx="123.709"
					ry="23.3576"
					fill="#ECF3FE"
				/>
				<path
					d="M165.838 35.4502C166.668 32.3555 169.849 30.5189 172.943 31.3481L210.417 41.3891L233.278 47.5146L247.722 74.4699L245.799 81.6494L238.104 110.367L224.215 162.2C223.386 165.294 220.205 167.131 217.11 166.302L142.164 146.22C139.069 145.39 137.232 142.209 138.061 139.115L165.838 35.4502Z"
					fill="#F0F6FF"
					stroke="#B4D2FF"
					strokeWidth="2.17544"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<line
					x1="180.322"
					y1="47.2162"
					x2="203.436"
					y2="53.4096"
					stroke="#B4D2FF"
					strokeWidth="3.62573"
					strokeLinecap="round"
				/>
				<line
					x1="177.326"
					y1="58.4232"
					x2="212.348"
					y2="67.8073"
					stroke="#B4D2FF"
					strokeWidth="3.62573"
					strokeLinecap="round"
				/>
				<line
					x1="174.32"
					y1="69.6302"
					x2="197.434"
					y2="75.8237"
					stroke="#B4D2FF"
					strokeWidth="3.62573"
					strokeLinecap="round"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M233.279 47.516L247.671 74.3745L236.278 71.3218C231.443 70.0261 228.573 65.0558 229.869 60.2203L233.273 47.5146L233.279 47.516Z"
					fill="#B4D2FF"
				/>
				<path
					d="M7.93114 57.9424C7.10191 54.8476 8.93846 51.6666 12.0332 50.8374L49.5066 40.7965L72.3676 34.6709L98.3547 50.7925L100.278 57.972L107.973 86.6898L121.862 138.522C122.691 141.617 120.855 144.798 117.76 145.627L42.813 165.709C39.7183 166.538 36.5373 164.702 35.708 161.607L7.93114 57.9424Z"
					fill="#F0F6FF"
					stroke="#B4D2FF"
					strokeWidth="2.17544"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<line
					x1="26.362"
					y1="60.8871"
					x2="49.4764"
					y2="54.6936"
					stroke="#B4D2FF"
					strokeWidth="3.62573"
					strokeLinecap="round"
				/>
				<line
					x1="29.3659"
					y1="72.0951"
					x2="64.3878"
					y2="62.7111"
					stroke="#B4D2FF"
					strokeWidth="3.62573"
					strokeLinecap="round"
				/>
				<line
					x1="32.3678"
					y1="83.3012"
					x2="55.4823"
					y2="77.1077"
					stroke="#B4D2FF"
					strokeWidth="3.62573"
					strokeLinecap="round"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M98.264 50.7346L86.8728 53.7868C82.0373 55.0825 77.067 52.2129 75.7714 47.3773L72.3672 34.6729L72.3715 34.6717L98.264 50.7346Z"
					fill="#B4D2FF"
				/>
				<path
					d="M76.4961 32.0096C76.4961 28.1874 79.5946 25.0889 83.4169 25.0889L129.7 25.0889H157.935L182.903 51.6906V60.5578V96.0268V160.044C182.903 163.866 179.805 166.965 175.982 166.965H83.4169C79.5946 166.965 76.4961 163.866 76.4961 160.044L76.4961 32.0096Z"
					fill="#F0F6FF"
					stroke="#B4D2FF"
					strokeWidth="2.59529"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<line
					x1="96.8307"
					y1="41.0931"
					x2="125.379"
					y2="41.0931"
					stroke="#B4D2FF"
					strokeWidth="4.32549"
					strokeLinecap="round"
				/>
				<line
					x1="96.8307"
					y1="54.9349"
					x2="140.086"
					y2="54.9349"
					stroke="#B4D2FF"
					strokeWidth="4.32549"
					strokeLinecap="round"
				/>
				<line
					x1="96.8307"
					y1="68.7767"
					x2="125.379"
					y2="68.7767"
					stroke="#B4D2FF"
					strokeWidth="4.32549"
					strokeLinecap="round"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M157.936 25.0889H157.934V40.7814C157.934 46.7536 162.775 51.5951 168.747 51.5951H182.814L157.936 25.0889Z"
					fill="#B4D2FF"
				/>
				<path
					d="M38.7626 26.2774C38.7663 26.8726 38.5855 27.4544 38.245 27.9426C37.9045 28.4308 37.421 28.8015 36.8612 29.0037L27.436 32.4708L23.9689 41.8887C23.7635 42.4465 23.3921 42.9279 22.9045 43.2679C22.417 43.6079 21.837 43.7903 21.2426 43.7903C20.6482 43.7903 20.0681 43.6079 19.5806 43.2679C19.0931 42.9279 18.7216 42.4465 18.5163 41.8887L15.04 32.4818L5.62033 29.0146C5.06253 28.8093 4.58114 28.4378 4.24111 27.9503C3.90107 27.4628 3.71875 26.8827 3.71875 26.2884C3.71875 25.694 3.90107 25.1139 4.24111 24.6264C4.58114 24.1389 5.06253 23.7674 5.62033 23.5621L15.0455 20.0949L18.5127 10.6771C18.718 10.1193 19.0894 9.63791 19.577 9.29787C20.0645 8.95783 20.6445 8.77552 21.2389 8.77552C21.8333 8.77552 22.4134 8.95783 22.9009 9.29787C23.3884 9.63791 23.7599 10.1193 23.9652 10.6771L27.4324 20.1022L36.8502 23.5694C37.4092 23.7687 37.8929 24.1358 38.2352 24.6206C38.5776 25.1053 38.7618 25.684 38.7626 26.2774ZM28.5437 8.75921H31.4634V11.6789C31.4634 12.0661 31.6172 12.4374 31.8909 12.7112C32.1647 12.985 32.536 13.1388 32.9232 13.1388C33.3104 13.1388 33.6817 12.985 33.9555 12.7112C34.2293 12.4374 34.3831 12.0661 34.3831 11.6789V8.75921H37.3028C37.69 8.75921 38.0613 8.60541 38.3351 8.33163C38.6088 8.05786 38.7626 7.68654 38.7626 7.29936C38.7626 6.91219 38.6088 6.54087 38.3351 6.26709C38.0613 5.99332 37.69 5.83951 37.3028 5.83951H34.3831V2.91981C34.3831 2.53263 34.2293 2.16132 33.9555 1.88754C33.6817 1.61377 33.3104 1.45996 32.9232 1.45996C32.536 1.45996 32.1647 1.61377 31.8909 1.88754C31.6172 2.16132 31.4634 2.53263 31.4634 2.91981V5.83951H28.5437C28.1565 5.83951 27.7852 5.99332 27.5114 6.26709C27.2376 6.54087 27.0838 6.91219 27.0838 7.29936C27.0838 7.68654 27.2376 8.05786 27.5114 8.33163C27.7852 8.60541 28.1565 8.75921 28.5437 8.75921ZM44.602 14.5986H43.1422V13.1388C43.1422 12.7516 42.9884 12.3803 42.7146 12.1065C42.4408 11.8327 42.0695 11.6789 41.6823 11.6789C41.2952 11.6789 40.9238 11.8327 40.6501 12.1065C40.3763 12.3803 40.2225 12.7516 40.2225 13.1388V14.5986H38.7626C38.3755 14.5986 38.0041 14.7524 37.7304 15.0262C37.4566 15.3 37.3028 15.6713 37.3028 16.0585C37.3028 16.4456 37.4566 16.817 37.7304 17.0907C38.0041 17.3645 38.3755 17.5183 38.7626 17.5183H40.2225V18.9782C40.2225 19.3653 40.3763 19.7367 40.6501 20.0104C40.9238 20.2842 41.2952 20.438 41.6823 20.438C42.0695 20.438 42.4408 20.2842 42.7146 20.0104C42.9884 19.7367 43.1422 19.3653 43.1422 18.9782V17.5183H44.602C44.9892 17.5183 45.3605 17.3645 45.6343 17.0907C45.9081 16.817 46.0619 16.4456 46.0619 16.0585C46.0619 15.6713 45.9081 15.3 45.6343 15.0262C45.3605 14.7524 44.9892 14.5986 44.602 14.5986Z"
					fill="#B4D2FF"
				/>
				<path
					d="M211.455 182.536C211.457 182.095 211.323 181.664 211.071 181.302C210.819 180.941 210.461 180.666 210.046 180.516L203.064 177.948L200.496 170.972C200.344 170.559 200.069 170.202 199.708 169.95C199.347 169.698 198.917 169.563 198.477 169.563C198.036 169.563 197.607 169.698 197.246 169.95C196.884 170.202 196.609 170.559 196.457 170.972L193.882 177.94L186.905 180.508C186.491 180.66 186.135 180.935 185.883 181.296C185.631 181.658 185.496 182.087 185.496 182.528C185.496 182.968 185.631 183.398 185.883 183.759C186.135 184.12 186.491 184.395 186.905 184.547L193.886 187.115L196.455 194.091C196.607 194.505 196.882 194.861 197.243 195.113C197.604 195.365 198.034 195.5 198.474 195.5C198.914 195.5 199.344 195.365 199.705 195.113C200.066 194.861 200.341 194.505 200.493 194.091L203.062 187.11L210.038 184.542C210.452 184.394 210.81 184.122 211.064 183.763C211.317 183.404 211.454 182.975 211.455 182.536ZM203.885 195.512H206.048V193.349C206.048 193.063 206.162 192.788 206.364 192.585C206.567 192.382 206.842 192.268 207.129 192.268C207.416 192.268 207.691 192.382 207.894 192.585C208.096 192.788 208.21 193.063 208.21 193.349V195.512H210.373C210.66 195.512 210.935 195.626 211.138 195.829C211.341 196.032 211.455 196.307 211.455 196.593C211.455 196.88 211.341 197.155 211.138 197.358C210.935 197.561 210.66 197.675 210.373 197.675H208.21V199.838C208.21 200.124 208.096 200.399 207.894 200.602C207.691 200.805 207.416 200.919 207.129 200.919C206.842 200.919 206.567 200.805 206.364 200.602C206.162 200.399 206.048 200.124 206.048 199.838V197.675H203.885C203.598 197.675 203.323 197.561 203.12 197.358C202.917 197.155 202.804 196.88 202.804 196.593C202.804 196.307 202.917 196.032 203.12 195.829C203.323 195.626 203.598 195.512 203.885 195.512ZM215.78 191.187H214.699V192.268C214.699 192.555 214.585 192.83 214.382 193.033C214.179 193.235 213.904 193.349 213.617 193.349C213.33 193.349 213.055 193.235 212.853 193.033C212.65 192.83 212.536 192.555 212.536 192.268V191.187H211.455C211.168 191.187 210.893 191.073 210.69 190.87C210.487 190.667 210.373 190.392 210.373 190.105C210.373 189.818 210.487 189.543 210.69 189.341C210.893 189.138 211.168 189.024 211.455 189.024H212.536V187.943C212.536 187.656 212.65 187.381 212.853 187.178C213.055 186.975 213.33 186.861 213.617 186.861C213.904 186.861 214.179 186.975 214.382 187.178C214.585 187.381 214.699 187.656 214.699 187.943V189.024H215.78C216.067 189.024 216.342 189.138 216.545 189.341C216.747 189.543 216.861 189.818 216.861 190.105C216.861 190.392 216.747 190.667 216.545 190.87C216.342 191.073 216.067 191.187 215.78 191.187Z"
					fill="#B4D2FF"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4598_62485">
					<rect width="254" height="202" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
